import jwt_decode from 'jwt-decode';
interface IJwt {
  exp: number;
  iss: string;
}

export const isAccessTokenPresent = (userObject: Record<string, unknown>) =>
  Boolean(userObject?.accessToken);

export const readTokenSubject = (accessToken: string): string | null => {
  try {
    return (jwt_decode(accessToken) as { sub?: string })?.sub ?? null;
  } catch (e) {
    return null;
  }
};

export const readTokenExpiry = (token: string): number | null => {
  try {
    const { exp } = jwt_decode(token) as { exp?: number };
    return typeof exp === 'number' ? exp : null;
  } catch (e) {
    return null;
  }
};

/**
 * Checks if the given JWT has expired
 * @param {string} accessToken - JWT
 * @returns A boolean value
 */
export const hasTokenExpired = (accessToken: string): boolean => {
  // 60 is for making current time forward by 60 secs
  const currentTime = Date.now() / 1000 + 60;
  const decoded: IJwt = jwt_decode(accessToken);
  return currentTime > decoded?.exp;
};

export const isTokenLapsed = (token: string): boolean => {
  try {
    return hasTokenExpired(token);
  } catch (e) {
    return false;
  }
};
